import React from 'react'

import { Mainpage } from 'Components/Mainpage'

export const App = () => {
  return (
    <>
      <Mainpage />
    </>
  )
}
